export default __webpack_public_path__ + "static/media/tvpg.05fc1bc4.png";